import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import Theme from 'components/common/Theme/Theme'
import Popover from 'components/common/Popover'

const WarrantyBadgeTitle = ({
  name,
  className,
  toolTipMessage
}) =>
  <Title data-at-warranty-badge-title className={ className }>
    { name }
    <StyledPopover small innerProps={{ popoverIconProps: { alt: `${name} tooltip` }}}>
      <Content>
        { toolTipMessage }
      </Content>
    </StyledPopover>
  </Title>

WarrantyBadgeTitle.propTypes = {
  className: PropTypes.string,
  name: PropTypes.string,
  toolTipMessage: PropTypes.string
}

export default WarrantyBadgeTitle

const Title = styled.div`
  margin-top: 10px;
  line-height: 16px;
  white-space: normal;
  color: ${Theme.colors.black_new};
  text-align: center;
  ${Mixin.font.GothamBook(14)}
  ${Media.mobile`
    padding: 10px 0;
  `}
`

const StyledPopover = styled(Popover)`
  margin-left: 6px;
  text-align: left;
  cursor: pointer;
`

const Content = styled.div`
  ${Mixin.font.GothamBook(12)}
  margin: 0;
  line-height: 18px;
 
  :hover {
    cursor: default;
  }
`
